// Reflux-based data store
// Deprecated - moved to Redux - see Backend & Moodboard for examples

// because of localStorage for server - 'use strict';

var _ = require('lodash');
var Cookie = require('js-cookie');
var Reflux = require('reflux');
var SuperAgent = require('superagent');

var isNode = typeof document === 'undefined';

var Actions = require('./actions');
var ParseAPI = require('../global/frontend-parse-api.js').ParseAPI;
import { getExperiment } from '../../../../common-js/content-experiments/Experiments';
var thankyou = require('../components/thankyou')

var LOCAL_STORAGE_KEY = 'store-0001';
var DB;

if (isNode) {
    // Drop-in replacement for localStorage that works in Node
    var MemoryStorage = require('memorystorage');
    DB = new MemoryStorage('strongp');
} else {
    // Safari Private Browsing Mode doesn't support localStorage - drop-in replacement that works in-memory
    try {
        DB = localStorage;
        DB.setItem(LOCAL_STORAGE_KEY + '-test', 'test');
    } catch (e) {
        // alert('You appear to be using Safari Private Browsing Mode - some functionality will be disabled');
        var MemoryStorageFactory = require('memorystorage');
        DB = MemoryStorageFactory(LOCAL_STORAGE_KEY);
    }
}

var Store = Reflux.createStore({
    listenables: [ Actions ],

    init: function() {
        this.data = DB.getItem(LOCAL_STORAGE_KEY);
        if (this.data)
        {
            this.data = JSON.parse(this.data);
            this.data.itemMap = {};
            this.data.items.forEach(item => {
                this.data.itemMap[item.id] = item;
            });
            if (!this.data.fields) {
                this.data.fields = {};
            }
            // If this is Optimize redirect, need to load new utm_expid here
            Actions.reloadExperiment();
        }
        else {
            this.data = {
                fields: {},
                budgetEstimates: [],
                items: [],
                itemMap: {},  // not saved in save()
                recentlyViewed: [],

                session: Cookie.get('PHPSESSID'),
                contentExperiment: getExperiment(),  // will return uninitialized 'none'

                sessionStartTime: new Date().getTime(),
                didGreet: false,
                showChat: false,
            };
            if (Payload.release.dev && Payload.release.deploy == 'local') {
                const k = Math.floor(Math.random()*3);
                this.data.fields = {
                    firstname: [ 'Adam-dev','Bob-dev','Charlie-dev' ][k],
                    lastname:  [ 'Mason', 'Potter', 'Fletcher' ][Math.floor(Math.random()*3)],
                    email:     `teamwaldman2020@gmail.com`,
                    phone:     '123-555-5678',
                    job:       'Dev',
                    company:    'EWWDC',
                    city:      'Montreal',
                    region:    'AR',
                };
            };
            this.save();
        }
    },
    save: function() {
        var storeData = {
            budgetEstimates: this.data.budgetEstimates,
            items:           this.data.items,
            fields:          this.data.fields,
            recentlyViewed:  this.data.recentlyViewed,

            session:           this.data.session,
            contentExperiment: this.data.contentExperiment,

            sessionStartTime: this.data.sessionStartTime,
            didGreet:         this.data.didGreet,
            showChat:         this.data.showChat,
        };
        DB.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storeData));
        this.trigger(this.data);
    },
    reload: function() {
        this.init();
        this.trigger(this.data);
    },
    
    // provides initial state to react components
    getInitialState: function() {
        return this.data;
    },

    // Action Handlers

    // Due to redirect, data is already initialized with experiment 'none'; need to reload to capture utm_expid
    reloadExperiment: function() {
        if (!this.data.contentExperiment || this.data.contentExperiment.expId == 'none') {
            this.data.contentExperiment = getExperiment();
        }
        this.save();
    },
    onViewedItem: function(item) {
        this.data.recentlyViewed = _.reject(this.data.recentlyViewed, (p) => {
            return p.id == item.id;
        });
        this.data.recentlyViewed.unshift(item);
        this.save();
    },
    onAddItem: function(item, type, quantity) {
        // remove leading Q for Quickship
        var itemID = _.trimStart(item.id, 'Q');

        this.reload();
        if (itemID in this.data.itemMap) {
            this.data.itemMap[itemID].quantity += quantity;
        } else {
            var storeItem = Object.assign(item, {  // TODO should be Object.assign({}, item, { ... ??
                id: itemID,
                filename: item.filename,
                quantity: quantity,
                type: type,
                filename: item.filename,
                width: item.width,
                height: item.height,
            });
            this.data.items.push(storeItem);
            this.data.itemMap[itemID] = storeItem;
        }
        this.save();
    },
    onSetItemQuantity: function(item, quantity) {
        this.reload();
        if (quantity <= 0) {
            var t = this.data.itemMap[item.id]; 
            delete this.data.itemMap[item.id];
            _.pull(this.data.items, t);
        } else {
            if (item.id in this.data.itemMap) {
                this.data.itemMap[item.id].quantity = quantity;
            } else {
                this.data.itemMap[item.id] = Object.assign(item, { quantity: quantity });
            }
        }
        this.save();
    },
    onSetItemNote: function(item, note) {
        this.reload();
        this.data.itemMap[item.id].note = note;
        this.save();
    },
    onSetBudgetEstimate: function(estimate) {
        this.reload();
        this.data.budgetEstimates.push(estimate);
        // this.data.fields['pf-area'] = null;
        this.save();
    },
    onSetProjectField: function(key, value) {
        this.reload();
        this.data.fields[key] = value;
        this.save();
    },
    
    onSetSessionStartTime: function(timestamp) {
        this.reload();
        this.data.sessionStartTime = timestamp;
        this.save();
    },
    onSetDidGreet: function(didGreet) {
        this.reload();
        this.data.didGreet = didGreet;
        this.save();
    },
    onSetShowChat: function(visible) {
        this.reload();
        this.data.showChat = visible;
        this.save();
    },

    onReset: function() {
        DB.clear();
        this.reload();
    },
    onSubmit: function(source,hiddenData) {
        this.reload();
        
        const items = () => {
            return this.data.items.length
                ? JSON.stringify(_.map(this.data.items, i =>({
                    id: i.id,
                    quantity: i.quantity,
                    note: i.note || ''
                })))
                : JSON.stringify([]);
        } 

        var _this = this;
        var submit = {
            source: source,
            session: this.data.session,
            contentExperiment: this.data.contentExperiment,
            
            email: this.data.fields.email,
            firstname: this.data.fields.firstname,
            lastname: this.data.fields.lastname,
            job: this.data.fields.job,
            company: this.data.fields.company,
            city: this.data.fields.city,
            region: this.data.fields.region || '',
            phone: this.data.fields.phone,
            path:hiddenData.path,
            device:hiddenData.device,
            browser:hiddenData.browser,
            ga:hiddenData.ga,
            items: items(),
            //specs
            area: this.data.fields.area || null,
            budget: this.data.fields.budget || null,
            date: this.data.fields.date || null,
            employees: this.data.fields.employees || null,
            industry: this.data.fields.industry || null,
            help: this.data.fields.help || null,
            description: this.data.fields.desc || null,
        };
        submit.budgetEstimates = this.data.budgetEstimates;

        var query = {
            command: 'submit',
            data: submit,
        };
        let thanked = false
        SuperAgent
            .post('/api/lead')
            .set('Content-Type', 'application/x-www-form-urlencoded')  // required for PHP's $_POST
            .send(submit)
            .end(function(err, res) {
                ParseAPI(query, err, res);
                DB.clear();
                thankyou()
            });
    },
});

// Reload store from LocalStorage when tab switched back to
if (!isNode) {
    document.addEventListener('visibilitychange', () => {
        Store.reload();
    })
}

module.exports = {
    Store: Store,
    Actions: Actions,
};



// WEBPACK FOOTER //
// ./src/store/store.js